import { render, staticRenderFns } from "./adminSettlementActions.vue?vue&type=template&id=40d66feb"
import script from "./adminSettlementActions.vue?vue&type=script&lang=js"
export * from "./adminSettlementActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports